import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdSolar_connectionsCatalog = z.any()
export type TagsGetMunicipalities_municipalityIdSolar_connectionsCatalog = z.infer<typeof tagsGetMunicipalities_municipalityIdSolar_connectionsCatalog>

export const paramsGetMunicipalities_municipalityIdSolar_connectionsCatalog = z.object({ "municipalityId": z.string().uuid() })
export type ParamsGetMunicipalities_municipalityIdSolar_connectionsCatalog = z.infer<typeof paramsGetMunicipalities_municipalityIdSolar_connectionsCatalog>

export const responseGetMunicipalities_municipalityIdSolar_connectionsCatalog = z.object({ "payload": z.object({ "providers": z.array(z.object({ "id": z.union([z.literal("dzd"), z.literal("solax"), z.literal("solaredge")]), "name": z.string(), "category": z.literal("solar"), "endpoint": z.string(), "intervalSeconds": z.number() })), "metrics": z.array(z.object({ "key": z.string(), "label": z.string(), "unit": z.string() })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetMunicipalities_municipalityIdSolar_connectionsCatalog = z.infer<typeof responseGetMunicipalities_municipalityIdSolar_connectionsCatalog>

interface IGetMunicipalities_municipalityIdSolar_connectionsCatalog extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdSolar_connectionsCatalog,
  params: ParamsGetMunicipalities_municipalityIdSolar_connectionsCatalog,
  response: ResponseGetMunicipalities_municipalityIdSolar_connectionsCatalog
}
export const URL = '/municipalities/:municipalityId/solar-connections/catalog'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdSolar_connectionsCatalog,
    params: paramsGetMunicipalities_municipalityIdSolar_connectionsCatalog,
    response: responseGetMunicipalities_municipalityIdSolar_connectionsCatalog
  }
}
export interface Municipalities_municipalityIdSolar_connectionsCatalog extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdSolar_connectionsCatalog
}